
import Vue from 'vue'
import SearchForm from './components/SearchForm.vue';
import SearchInfo from './components/SearchInfo.vue';
import FiltersComponent from './components/Filters.vue';
import HitsComponent from './components/Hits.vue';
import PaginationComponent from './components/Pagination.vue';

interface AppData {}

interface AppMethods {}

interface AppComputed {
	isSearch: boolean,
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		isSearch() {
			return this.$store.state.isSearch;
		}
	},
	components: {
		SearchForm,
		SearchInfo,
		FiltersComponent,
		HitsComponent,
		PaginationComponent,
	}
})
